import { initI18n } from 'www/utils'
import getDoctorDescription from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/functions/getDoctorDescription'

describe('getDoctorDescription', () => {
  describe('Если передан стаж, но не категория и степень', () => {
    test.each([
      { experience: '', expected: '' },
      { experience: '1 год', expected: 'Стаж 1 год' },
      { experience: '3 года', expected: 'Стаж 3 года' },
      { experience: '10 лет', expected: 'Стаж 10 лет' },
    ])('Тогда функция вернёт текст "$expected", для стажа = "$experience"', async ({ experience, expected }) => {
      await initI18n()
      expect(getDoctorDescription({ experience })).toBe(expected)
    })
  })
  describe('Если передан стаж и категория, но не степень', () => {
    test.each([
      { experience: '', category: '', expected: '' },
      { experience: '', category: 'Высшая', expected: 'Высшая категория' },
      { experience: '1 год', category: '', expected: 'Стаж 1 год' },
      { experience: '1 год', category: 'Нет', expected: 'Стаж 1 год • Нет категории' },
    ])(
      'Тогда функция вернёт текст "$expected", для стажа = "$experience", категории = "$category"',
      async ({ experience, category, expected }) => {
        await initI18n()
        expect(getDoctorDescription({ experience, category })).toBe(expected)
      },
    )
  })
  describe('Если передан стаж, категория и степень', () => {
    test.each([
      {
        experience: '', category: '', science: '', expected: '',
      },
      {
        experience: '1 год', category: '', science: '', expected: 'Стаж 1 год',
      },
      {
        experience: '', category: 'Высшая', science: '', expected: 'Высшая категория',
      },
      {
        experience: '', category: '', science: 'Степень 1', expected: 'Степень 1',
      },
      {
        experience: '1 год', category: 'Нет', science: '', expected: 'Стаж 1 год • Нет категории',
      },
      {
        experience: '', category: 'Нет', science: 'Степень 2', expected: 'Нет категории, степень 2',
      },
      {
        experience: 'Год', category: '', science: 'Степень 3', expected: 'Стаж Год, степень 3',
      },
      {
        experience: '1 год', category: 'нет', science: 'Степень 4', expected: 'Стаж 1 год • Нет категории, степень 4',
      },
    ])(
      'Тогда функция вернёт текст "$expected", для стажа = "$experience", категории = "$category", степени = "$science"',
      async ({
        experience, category, science, expected,
      }) => {
        await initI18n()
        expect(getDoctorDescription({ experience, category, science })).toBe(expected)
      },
    )
  })
  describe('Если передана категория, но не стаж и степень', () => {
    test.each([
      { category: '', expected: '' },
      { category: 'Высшая', expected: 'Высшая категория' },
      { category: '1', expected: '1 категория' },
      { category: 'нет', expected: 'Нет категории' },
      { category: 'Нет', expected: 'Нет категории' },
      { category: 'нЕТ', expected: 'Нет категории' },
    ])('Тогда функция вернёт текст "$expected", для категории = "$category"', async ({ category, expected }) => {
      await initI18n()
      expect(getDoctorDescription({ category })).toBe(expected)
    })
  })
  describe('Если передана категория и степень, но не стаж', () => {
    test.each([
      { category: '', science: '', expected: '' },
      { category: 'Высшая', science: '', expected: 'Высшая категория' },
      { category: '', science: 'Степень 4', expected: 'Степень 4' },
      { category: 'нет', science: 'Степень 4', expected: 'Нет категории, степень 4' },
    ])('Тогда функция вернёт текст "$expected", для категории = "$category", степени = "$science"', async ({ category, science, expected }) => {
      await initI18n()
      expect(getDoctorDescription({ category, science })).toBe(expected)
    })
  })
  describe('Если передана степень, но не стаж и категория', () => {
    test.each([
      { science: '', expected: '' },
      { science: 'Высшая', expected: 'Высшая' },
      { science: '1', expected: '1' },
      { science: 'нет', expected: 'Нет степени' },
      { science: 'Нет', expected: 'Нет степени' },
      { science: 'нЕТ', expected: 'Нет степени' },
    ])('Тогда функция вернёт текст "$expected", для степени = "$science"', ({ science, expected }) => {
      expect(getDoctorDescription({ science })).toBe(expected)
    })
  })
  describe('Если не переданы значения', () => {
    test('Тогда функция вернёт пустую строку', () => {
      expect(getDoctorDescription({})).toBe('')
    })
  })
  describe('Если переданы степень, стаж и категория, но значение не строковое', () => {
    test.each([
      { value: 0 },
      { value: 10 },
      { value: false },
      { value: true },
      { value: null },
      { value: undefined },
      { value: NaN },
      { value: [] },
      { value: {} },
    ])('Тогда функция вернёт пустую строку для значения = "$value"', ({ value }) => {
      expect(getDoctorDescription({ experience: value })).toBe('')
      expect(getDoctorDescription({ category: value })).toBe('')
      expect(getDoctorDescription({ science: value })).toBe('')
      expect(getDoctorDescription({ experience: value, category: value })).toBe('')
      expect(getDoctorDescription({ experience: value, science: value })).toBe('')
      expect(getDoctorDescription({ experience: value, category: value, science: value })).toBe('')
      expect(getDoctorDescription({ category: value, science: value })).toBe('')
    })
  })
})
